import Backbone from 'backbone'
import constants from 'scoreboard/components/constants'
import loadingDots from './loading-dots.hbs'

/**
 * Common operations for displaying and turning off loading dots
 *
 * @param el
 *            The loading dots container. The loading dots are appended to this
 *            element, so it is important NOT to apply the 'loading-dots' css,
 *            and rather use something like 'loading-dots-container'
 *
 * Sample Usage:
 *
 * <pre>
 * this.loadingDots = new LoadingDots({
 *     el: this.$('.loading-dots-container')
 * }).render()
 * // when ready
 * this.loadingDots.clear()
 * </pre>
 */
var LoadingDots = Backbone.View.extend({

	render: function() {
		if (this.loadingTimeout) {
			clearTimeout(this.loadingTimeout)
		}
		this.loadingTimeout = setTimeout(function() {
			this.trigger('render')
			this.$el.append(loadingDots())
			this.$el.removeClass('is-not-displayed')
			this.trigger('dots-rendered')
		}.bind(this), constants.LOADING_TIME)

		this.loading = true

		return this
	},

	/**
	 * Clears the loading dots but leaves the container available to
	 * show them again later.  When they are needed invoke 'render' again
	 */
	clear: function() {
		clearTimeout(this.loadingTimeout)
		this.$el.empty()
		this.loading = false
	},

	/**
	 * Clears any timeout that was set to delay the rendering of the loading dots
	 * and removes the loading dots DOM element
	 */
	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		clearTimeout(this.loadingTimeout)
	},

	/**
	 * Loading dots will be removed when the stream emits the first data event,
	 * or the end of the stream is reached with no data.
	 *
	 * @param stream An event emitter with 'data' and 'end' events
	 */
	observeStream: function(stream) {
		stream.once('data', this.remove.bind(this))
		stream.on('end', this.remove.bind(this))
	}

})

export default LoadingDots

LoadingDots.__filename__ = 'components/loading-dots.js'
